import React from "react";

import { DashboardLayout } from "@/components/layout";
import { Card, CardContent, PageHeader } from "@/components/ui";
import {
  useFormVersionLagQuery,
  usePublishRejectionsQuery,
} from "@/graphql/generated";

export default function PublishErrors() {
  const { data, isLoading, isError } = usePublishRejectionsQuery({
    limit: 100,
  });
  const rows = data?.publishRejections ?? [];
  const { data: lagData } = useFormVersionLagQuery();
  const lag = (lagData?.formVersionLag ?? []).filter((r) => r.behind > 0);
  return (
    <DashboardLayout activePath="/catalog/publish-errors">
      <PageHeader
        title="Publish Errors"
        subtitle="Publishes that failed, with the error text as saved"
        breadcrumbs={[{ label: "Publish Errors", active: true }]}
      />
      {lag.length > 0 && (
        <div className="mb-4">
          <Card>
            <CardContent className="p-5 text-sm">
              <div className="mb-2 font-medium">
                Products not yet on their store's current form
              </div>
              <ul className="space-y-1">
                {lag.map((r) => (
                  <li key={`${r.marketplace}|${r.productType}`}>
                    {r.marketplace} {r.productType}: {r.behind} of {r.stamped}{" "}
                    products behind {r.stamp}
                  </li>
                ))}
              </ul>
            </CardContent>
          </Card>
        </div>
      )}
      <Card>
        <CardContent className="p-0">
          {isLoading ? (
            <div className="p-6 text-sm text-slate-500">Loading…</div>
          ) : isError ? (
            <div className="p-6 text-sm text-slate-500">
              Could not load publish errors.
            </div>
          ) : rows.length === 0 ? (
            <div className="p-6 text-sm text-slate-500">
              No rejected publishes.
            </div>
          ) : (
            <table className="w-full text-sm">
              <thead className="text-left text-slate-500">
                <tr>
                  <th className="px-5 py-3">Store</th>
                  <th>Product type</th>
                  <th>When</th>
                  <th>Error text</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-200 dark:divide-slate-800">
                {rows.map((r) => (
                  <tr key={r.id}>
                    <td className="px-5 py-3">{r.marketplace}</td>
                    <td>{r.productType ?? "—"}</td>
                    <td>{new Date(r.failedAt).toLocaleString()}</td>
                    <td className="whitespace-pre-wrap">{r.error}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </CardContent>
      </Card>
    </DashboardLayout>
  );
}
